// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uJKe","badges":"styles_badges__1K9xo"};